import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { BaseTaxFragment, FullProductFragment } from "graphql.generated";

import { EditableCharge } from "src/app/job/job-workorders/job-workorders.state";

import { ActionSource } from "../../state/action-sources";

export const JobMutateChargeActions = createActionGroup({
  source: ActionSource.MUTATE_CHARGE_DIALOG,
  events: {
    'Product Autocomplete Input Changed': props<{ value: string }>(),
    'Product Selected': props<{ selectedProduct: FullProductFragment }>(),
    'Product With Price Selected': props<{ selectedProduct: FullProductFragment, price: FullProductFragment['prices'][number] }>(),
    'Description Input Changed': props<{ value: string }>(),
    'Percentage Amount Input Changed': props<{ amount: number }>(),
    'Fixed Amount Input Changed': props<{ amount: number }>(),
    'Fixed Amount Input Blurred': emptyProps(),
    'Quantity Input Changed': props<{ quantity: number }>(),
    'Event Selected': props<{ eventIds: string[] }>(),
    'Taxes Selection Changed': props<{ taxes: BaseTaxFragment[] }>(),
    'Remove Tax Button Clicked': props<{ taxId: string }>(),
    'Expense Selected': props<{ expenseId: string, index: number }>(),
    'Unit Cost Input Changed': props<{ unitCost: number, index: number }>(),
    'Remove Expense Button Clicked': props<{ index: number }>(),
    'Add Expense Button Clicked': emptyProps(),
    'Charge Loaded': props<{ charge: EditableCharge; eventId: string; }>(),
  },
})
